export enum CloseScheduleType {
  ClosedBySystem = 1,
  ClosedByUser = 2,
  ClosedForMovement = 3,
}
